import icon from "../../assets/poe.svg";
import type { Property } from "../../types";

export const readerPowerMethod: Property = {
  id: "readerPowerMethod",
  title: "readerPowerMethod.title",
  icon,
};
